// Тема-зависимые цветовые токены: одна и та же сетка имён, два набора значений (light/dark).
// Эстетика в духе Telegram (тёплый акцент, мягкие пузыри), но палитра СВОЯ (инв.2 — не копируем
// фирменные ассеты/цвета). Имена — логические; значения подставляет ThemeProvider на корне как
// набор CSS custom properties (data-theme="light|dark"). Компоненты используют только var(--…).
/** Светлая тема. */
export const lightPalette = {
    colorBg: '#ffffff',
    colorBgSecondary: '#f1f3f5',
    colorSurface: '#ffffff',
    colorSurfaceHover: '#eceff1',
    colorText: '#101418',
    colorTextMuted: '#707a82',
    colorTextInverse: '#ffffff',
    colorAccent: '#2f7bdc',
    colorAccentMuted: 'rgba(47, 123, 220, 0.16)',
    colorBubbleOut: '#d4e7ff',
    colorBubbleOutText: '#0d1b2a',
    colorBubbleIn: '#f1f3f5',
    colorBubbleInText: '#101418',
    colorUnread: '#2f7bdc',
    colorUnreadMuted: '#aeb6bd',
    colorOnline: '#3bbf63',
    colorDanger: '#e04848',
    colorDivider: '#e2e6ea',
    colorOverlay: 'rgba(0, 0, 0, 0.55)',
    colorCodeBg: 'rgba(16, 20, 24, 0.06)',
    colorLink: '#2f7bdc',
    senderColors: ['#cc4f44', '#3f8f3f', '#b8821f', '#2f7bdc', '#9b51c4', '#1f9aa6', '#c4528a'],
};
/** Тёмная тема. */
export const darkPalette = {
    colorBg: '#0e1419',
    colorBgSecondary: '#161e25',
    colorSurface: '#1b2530',
    colorSurfaceHover: '#243140',
    colorText: '#e9edf0',
    colorTextMuted: '#8a97a3',
    colorTextInverse: '#ffffff',
    colorAccent: '#4a93e6',
    colorAccentMuted: 'rgba(74, 147, 230, 0.22)',
    colorBubbleOut: '#2b5278',
    colorBubbleOutText: '#eef4fb',
    colorBubbleIn: '#1b2530',
    colorBubbleInText: '#e9edf0',
    colorUnread: '#4a93e6',
    colorUnreadMuted: '#3a4753',
    colorOnline: '#46c46a',
    colorDanger: '#ec5b5b',
    colorDivider: '#28333f',
    colorOverlay: 'rgba(0, 0, 0, 0.7)',
    colorCodeBg: 'rgba(255, 255, 255, 0.08)',
    colorLink: '#6fb0f3',
    senderColors: ['#e8786d', '#6cc06c', '#e0b04a', '#5aa9f0', '#c07be0', '#4fc4cf', '#ee79b3'],
};
/** Два набора значений по resolved-теме. */
export const palettes = {
    light: lightPalette,
    dark: darkPalette,
};
//# sourceMappingURL=palette.js.map